import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class VisitService {
    static getVisitItems(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.get(`visit-items?filter=${qs}`));
    }
    static markVisitItemViewed(dto) {
        return lastValueFrom(BaseService.post(`visit-item-mark-viewed`, dto));
    }
    static markVisitItemLocked(dto) {
        return lastValueFrom(BaseService.post(`visit-item-mark-locked`, dto));
    }
    static markVisitItemUnlockedGood(dto) {
        return lastValueFrom(BaseService.post(`visit-item-mark-unlocked-good`, dto));
    }
    static markVisitItemUnlockedBurn(dto) {
        return lastValueFrom(BaseService.post(`visit-item-mark-unlocked-burn`, dto));
    }
    static markVisitItemUnviewed(dto) {
        return lastValueFrom(BaseService.post(`visit-item-mark-unviewed`, dto));
    }
    static markVisitItemUnprinted(dto) {
        return lastValueFrom(BaseService.post(`visit-item-mark-unprinted`, dto));
    }
    static saveVisitItemNotes(dto) {
        return lastValueFrom(BaseService.post(`visit-item-notes`, dto));
    }
    // ======================================================================
    // Visit History
    // ======================================================================
    static getVisitHistory(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`visit-history?filter=${qs}`, pageNumber));
    }
}
